import React, { useEffect } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import HowItWorksSection from './HowItWorksSection';
import AboutSection from './AboutSection';
import TestimonialsSection from './TestimonialsSection';
import PricingSection from './PricingSection';
import ZoneSection from './ZoneSection';
import FAQSection from './FAQSection';
import ContactForm from './ContactForm';
import Footer from './Footer';
import ChatBot from './ChatBot';
import CookieConsent from './CookieConsent';
import { initGA } from '../lib/analytics';

const LandingPage = () => {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <div className="min-h-screen bg-page">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <HowItWorksSection />
        <AboutSection />
        <TestimonialsSection />
        <PricingSection />
        <ZoneSection />
        <FAQSection />
        <ContactForm />
      </main>
      <Footer />
      <ChatBot />
      <CookieConsent />
    </div>
  );
};

export default LandingPage;
